import { Subject } from "rxjs";

const AuthSubject = new Subject();

export { AuthSubject };



// WEBPACK FOOTER //
// ./src/shared/AuthSubject.js